module.exports = "pegasus_template/assets/tech/small/5.jpg";